import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'

export const editPolicies = async (data: object) => {
  return axios.put(endpoints.cancelPolicies, data)
}

export const useEditPolicies = () => {
  const client = useQueryClient()
  return useMutation(editPolicies, {
    onSuccess: () => {
      client.invalidateQueries([ApiKey.policies, ApiKey.list])
      client.invalidateQueries([ApiKey.PreviousPolicies, ApiKey.list])
    },
  })
}
